import React, {useCallback} from 'react';
import {IAuthData} from 'types';
import useLocalStorageState from './useLocalStorageState';
import {AUTH_DATA_STORE_KEY} from 'const';

// const contextValue = {
//    authData: {} as IAuthData,
//    setAuthData: (data: IAuthData) => {},
// };

type IAuthContext = ReturnType<typeof useAuthContextBuilder>;
export const authContext = React.createContext<IAuthContext>({} as IAuthContext);

type AuthContextProviderProps = {
   children: React.ReactNode;
};

export const useAuthContext = () => {
   const value = React.useContext(authContext);
   return value;
};

const useAuthContextBuilder = () => {
   const [authData, setAuthData] = useLocalStorageState(AUTH_DATA_STORE_KEY, {} as IAuthData);

   const login = useCallback(
      (data: IAuthData) => {
         setAuthData(data);
      },
      [setAuthData]
   );

   const logout = () => login({} as IAuthData);

   return {
      login,
      logout,
      isAuth: authData.auth,
      authData,
   };
};

let authExternal: IAuthContext;
export const AuthContextProvider = ({children}: AuthContextProviderProps) => {
   authExternal = useAuthContextBuilder();

   const {Provider} = authContext;
   return <Provider value={authExternal}>{children}</Provider>;
};

export const getAuthExternal = () => authExternal;
